import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './firebase'; // Initialize Firebase
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import Products from './components/Products';
import Mission from './components/Mission';
import Footer from './components/Footer';
import WidgetTest from './components/WidgetTest';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import BAA from './components/BAA';

function HomePage() {
  return (
    <>
      <Navigation />
      <Hero />
      <Products />
      <Mission />
      <Footer />
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/widget-test" element={<WidgetTest />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/baa" element={<BAA />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
